<div class="main-estimate-summary" *ngIf="estimateSummaryValues">

  <div class="values">
    <div class="section">
      <div class="text">Subtotal</div>
      <div class="d-flex">
        <div class="text">$</div>
        <div class="text fw-600">{{estimateSummaryValues.subtotal.toFixed(2)}}</div>
      </div>
    </div>

    <div class="section"
         *ngIf="
         !isNaN(+estimateSummaryValues.discountDisplay)
         && estimateSummaryValues.discountDisplay !== '0'
         && estimateSummaryValues.discountDisplay !== '0.00'"
    >
      <div class="d-flex align-items-center gap--10">
        <div class="text">Discount</div>
        <div class="discount-switcher">
          <div class="option" (click)="readonly ? null : toggleDiscountType('percent')"
               [class.active]="estimateVersion.discountType === 'percent'"
          >
            %
          </div>
          <div class="option" (click)="readonly ? null : toggleDiscountType('amount')"
               [class.active]="estimateVersion.discountType === 'amount'"
          >
            $
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="d-flex align-items-center">
          <div class="text">-</div>
          <div class="text">{{currentDiscountType === 'amount' ? '$' : '&nbsp;'}}</div>
        </div>
        <div class="text fw-600">{{estimateSummaryValues.discountDisplay}}</div>
        <div class="text" *ngIf="currentDiscountType === 'percent'">%</div>
      </div>
    </div>

    <div class="section">
      <div class="text">Sales Tax</div>
      <div class="d-flex">
        <div class="text">$</div>
        <div class="text fw-600">{{estimateSummaryValues.salesTax.toFixed(2)}}</div>
      </div>
    </div>
  </div>

  <div class="total-line"></div>

  <div class="d-flex justify-content-between align-items-center">
    <div class="text fw-700">Total</div>
    <div class="text fw-700" id="editable-total-amount">
      ${{estimateSummaryValues.total.toFixed(2)}}
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mt--20" *ngIf="estimateSummaryValues.total">
    <div class="d-flex gap--22 align-items-center">
      <div class="d-flex gap--4 align-items-center">
        <div class="text fw-600">Deposit</div>
        <app-icon src="question-mark-tooltip"
                  matTooltip="Payment Splitting available on the sent estimate. Nuvei processed Payments updated automatically, update other payment methods in payments"
                  [matTooltipShowDelay]="300"
                  matTooltipClass="deposit-tooltip"
                  class="scale--85"
                  #tooltip="matTooltip"
                  (click)="tooltip.show()"
                  [hideTooltipOnScroll]="tooltip"
                  [style.pointer-events]="'auto'"
        ></app-icon>
      </div>
      <div class="deposit-input-block">
        <mat-form-field appearance="outline" appFormFieldFilled [class.error]="depositAbove" [class.disabled]="readonly" [class.filled]="readonly">
          <div class="d-flex" *ngIf="estimateVersion.depositType === 'amount'">
            <div class="d-flex align-items-center mr--2">$</div>
            <input matInput [formControl]="depositAmountFormControl"
                   (focus)="depositFocus$.next(true); depositFocus.emit(true)"
                   (focusout)="depositFocus$.next(false); depositFocus.emit(false)"
                   id="editable-deposit-amount"
                   autocomplete="off"
                   inputmode="decimal"
                   mask="separator.2" thousandSeparator="" decimalMarker="."
                   [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                   (keydown)="decimalOnly($event)"
                   (paste)="onPaste($event)"
                   replaceCommaWithDot
                   [readonly]="readonly"
            >
            <div class="deposit-error" *ngIf="depositAbove">Above estimate amount</div>
          </div>
          <div class="d-flex" *ngIf="estimateVersion.depositType === 'percent'">
            <input matInput class="tar"
                   [formControl]="depositPercentFormControl"
                   (focus)="depositFocus$.next(true); depositFocus.emit(true)"
                   (focusout)="depositFocus$.next(false); depositFocus.emit(false)"
                   id="editable-deposit-percent"
                   autocomplete="off"
                   inputmode="decimal"
                   mask="separator.2" thousandSeparator="" decimalMarker="."
                   [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                   (keydown)="decimalOnly($event)"
                   (paste)="onPaste($event)"
                   replaceCommaWithDot
                   [readonly]="readonly"
            >
            <div class="d-flex align-items-center ml--2" style="color: #1B1B1B">%</div>
            <div class="deposit-error" *ngIf="depositAbove">Above estimate amount</div>
          </div>
          <div class="deposit-divider"></div>
          <app-icon src="change" class="ml--4 clickable" (click)="readonly ? null : toggleDepositType()"></app-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex" *ngIf="displayDeposit !== 0 && showDisplayDeposit"
         [class.deposit-danger]="(estimateVersion.depositType === 'percent' && displayDeposit > estimateSummaryValues.total)
         || (estimateVersion.depositType === 'amount') && displayDeposit > 100"
    >
      <div class="text fw-600" *ngIf="estimateVersion.depositType === 'percent'">$</div>
      <div class="text fw-600">
        {{formatDeposit(displayDeposit)}}
      </div>
      <div class="text fw-600" *ngIf="estimateVersion.depositType === 'amount'">%</div>
    </div>
  </div>

  <div class="mt--16 d-flex flex-column gap--8" *ngIf="displayDeposit" fadeIn="1000">
    <div class="d-flex align-items-center gap--8">
      <div class="d-flex align-items-center gap--4">
        <div class="fw-600 text">Surcharge</div>
        <app-icon src="question-mark-tooltip"
                  matTooltip="Set amount to reflect only what's paid by card"
                  [matTooltipShowDelay]="300"
                  class="scale--85"
                  #tooltip="matTooltip"
                  (click)="tooltip.show()"
                  [hideTooltipOnScroll]="tooltip"
                  [style.pointer-events]="'auto'"
        ></app-icon>
      </div>
      <mat-slide-toggle [checked]="estimateVersion.surcharge!"
                        (change)="readonly ? null : toggleSurcharge($event)"
                        class="slide-toggle"
                        [disabled]="readonly"
                        [class.disabled]="readonly"
      ></mat-slide-toggle>
      <div class="text">3%</div>
    </div>
    <div *ngIf="surchargeError" class="surcharge-error" fadeIn="500">{{ surchargeError }}</div>
  </div>

  <div class="d-flex align-items-center justify-content-between mt--16">
    <div class="d-flex align-items-center gap--8">
      <div class="d-flex align-items-center gap--4">
        <div class="fw-600 text">Signature</div>
        <app-icon src="question-mark-tooltip"
                  matTooltip="Request a signature from your customer"
                  [matTooltipShowDelay]="300"
                  class="scale--85"
                  #tooltip="matTooltip"
                  (click)="tooltip.show()"
                  [hideTooltipOnScroll]="tooltip"
                  [style.pointer-events]="'auto'"
        ></app-icon>
      </div>
      <mat-slide-toggle [checked]="estimateVersion.signature!"
                        (change)="readonly ? null : toggleSignature($event.checked) "
                        class="slide-toggle"
                        [disabled]="readonly"
                        [class.disabled]="readonly"
      ></mat-slide-toggle>
    </div>
    <div class="text required" *ngIf="estimateVersion.signature">Required</div>
  </div>

</div>
